<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <!-- ═══ STEP 1: Group Sub Menu Picker ═══ -->
  <ng-container *ngIf="isSubPickerView">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">กลุ่มเมนูย่อย</h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">เลือกกลุ่มเมนูย่อยเพื่อจัดการรายการเมนูภายใน</p>
      </div>
      <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
        <button (click)="toggleDashboard()"
          class="w-full sm:w-auto px-4 py-3 bg-white/95 dark:bg-slate-900/95 text-slate-600 dark:text-slate-300 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all font-bold flex items-center justify-center gap-2 active:scale-95">
          <span class="material-icons text-[18px]">{{ isDashboardOpen() ? 'bar_chart' : 'show_chart' }}</span>
          แดชบอร์ด
        </button>
        <button (click)="exportMenuData()" [disabled]="isExporting()"
          class="w-full sm:w-auto px-4 py-3 bg-emerald-500 dark:bg-emerald-500 text-white dark:text-white hover:text-white/90 dark:hover:text-white/90 hover:scale-98 cursor-pointer rounded-2xl shadow-sm border border-slate-100/50 transition-all font-bold flex items-center justify-center gap-2 active:scale-95 disabled:opacity-50">
          <span class="material-icons text-[18px]">download</span>
          ส่งออกเมนู (Export)
        </button>
        <button (click)="fileInput.click()"
          class="w-full sm:w-auto px-4 py-3 bg-blue-500 dark:bg-blue-500 text-white dark:text-white hover:text-white/90 dark:hover:text-white/90 hover:scale-98 cursor-pointer rounded-2xl shadow-sm border border-slate-100/50 transition-all font-bold flex items-center justify-center gap-2 active:scale-95">
          <span class="material-icons text-[18px]">upload</span>
          นำเข้าเมนู (Import)
        </button>
        <input type="file" #fileInput (change)="onFileSelected($event)" accept=".json" class="hidden">
        <button (click)="onRefresh()"
          class="w-full sm:w-auto p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 dark:text-slate-400 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all active:scale-95 flex items-center justify-center">
          <span class="material-icons">refresh</span>
        </button>
        <button *ngIf="canCreate" (click)="navigateToCreateSub()"
          class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-2xl hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2">
          <span class="material-icons text-xl">add_circle</span>
          สร้างกลุ่มเมนูย่อย
        </button>
      </div>
    </div>

    <div *ngIf="isDashboardOpen()" class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
      <div *ngFor="let stat of dashboardStats(); let i = index"
        class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-2xl p-6 shadow-2xl border border-slate-100/50 hover:-translate-y-1 transition-all relative overflow-hidden group"
        [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">
        <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08]"
          [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>
        <div class="relative z-10 flex justify-between items-start mb-4">
          <div class="w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
            [ngClass]="stat.color.replace('text-', 'bg-').replace('500', '50') + ' ' + stat.color">
            <span class="material-icons text-2xl">{{ stat.icon }}</span>
          </div>
        </div>
        <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">{{ stat.title }}</h4>
        <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ stat.value }}</div>
      </div>
    </div>

    <div
      class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden p-6">
      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">folder_open</span>
          เลือกกลุ่มเมนูย่อย ({{ filteredGroupSubs().length }})
        </h3>
        <div class="relative w-full sm:max-w-sm">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
          <input type="text" placeholder="ค้นหากลุ่มเมนูย่อย..." [ngModel]="subSearchText()"
            (ngModelChange)="subSearchText.set($event)"
            class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none">
        </div>
      </div>

      <div *ngFor="let group of groupedSubs()" class="mb-8 last:mb-0">
        <h4 class="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4 flex items-center gap-2">
          <span class="material-icons text-amber-500 text-base">layers</span>
          {{ group.groupMenuName }}
        </h4>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <div *ngFor="let sub of group.items; trackBy: trackById"
            class="relative text-left p-5 bg-slate-50 dark:bg-slate-800/50 hover:bg-amber-50 dark:hover:bg-amber-900/10 rounded-2xl border border-slate-100 dark:border-slate-700 hover:border-amber-300 transition-all hover:-translate-y-0.5 hover:shadow-lg group cursor-pointer"
            [class.opacity-70]="!sub.enable" (click)="selectGroupSub(sub)">
            <div class="flex items-start justify-between mb-3">
              <div
                class="w-10 h-10 rounded-xl bg-sky-100 dark:bg-sky-900/30 text-sky-600 flex items-center justify-center">
                <span class="material-icons">{{ sub.icon || 'folder' }}</span>
              </div>
              <span class="text-[10px] font-bold uppercase px-2 py-1 rounded-full"
                [ngClass]="sub.enable ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-500'">
                {{ sub.enable ? 'เปิด' : 'ปิด' }}
              </span>
            </div>
            <p class="font-bold text-slate-800 dark:text-slate-100 group-hover:text-amber-600 transition-colors pr-16">
              {{ sub.name }}</p>
            <p class="text-xs text-slate-400 mt-1">ลำดับ: {{ sub.number }} · ID: {{ sub.id }}</p>
            <p class="text-sm font-semibold text-amber-500 mt-3 flex items-center gap-1">
              <span class="material-icons text-base">list</span>
              {{ sub.menuCount }} รายการเมนู
            </p>

            <div
              class="absolute top-3 right-3 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <button *ngIf="canUpdate" (click)="navigateToEditSub(sub, $event)"
                class="w-8 h-8 rounded-lg flex items-center justify-center bg-white/90 dark:bg-slate-900/90 border border-slate-100 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all shadow-sm">
                <span class="material-icons text-base">edit</span>
              </button>
              <button *ngIf="canDelete" (click)="onDeleteSub(sub, $event)"
                class="w-8 h-8 rounded-lg flex items-center justify-center bg-white/90 dark:bg-slate-900/90 border border-slate-100 hover:border-rose-400 text-slate-400 hover:text-rose-500 transition-all shadow-sm">
                <span class="material-icons text-base">delete</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="filteredGroupSubs().length === 0 && !isLoading()" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2">folder_off</span>
        <p class="font-bold">ไม่พบกลุ่มเมนูย่อย</p>
        <p *ngIf="canCreate" class="text-sm mt-1">กดปุ่ม "สร้างกลุ่มเมนูย่อย" เพื่อเริ่มต้น</p>
      </div>
    </div>
  </ng-container>

  <!-- ═══ STEP 2: Menu Lists Table ═══ -->
  <ng-container *ngIf="isMenuTableView && selectedGroupSub() as sub">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <button (click)="backToSubPicker()"
          class="mb-3 flex items-center gap-1 text-sm font-bold text-slate-400 hover:text-amber-500 transition-colors">
          <span class="material-icons text-base">arrow_back</span>
          กลับเลือกกลุ่มเมนูย่อย
        </button>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">{{ sub.name }}</h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
          กลุ่มหลัก: <span class="font-bold text-amber-500">{{ sub.groupMenuName }}</span>
          · จัดการรายการเมนูในกลุ่มนี้
        </p>
      </div>
      <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
        <button (click)="exportMenuData()" [disabled]="isExporting()"
          class="w-full sm:w-auto px-4 py-3 bg-emerald-500 dark:bg-emerald-500 text-white dark:text-white hover:text-white/90 dark:hover:text-white/90 hover:scale-98 cursor-pointer rounded-2xl shadow-sm border border-slate-100/50 transition-all font-bold flex items-center justify-center gap-2 active:scale-95 disabled:opacity-50">
          <span class="material-icons text-[18px]">download</span>
          ส่งออกเมนู (Export)
        </button>
        <button (click)="fileInputSub.click()"
          class="w-full sm:w-auto px-4 py-3 bg-blue-500 dark:bg-blue-500 text-white dark:text-white hover:text-white/90 dark:hover:text-white/90 hover:scale-98 cursor-pointer rounded-2xl shadow-sm border border-slate-100/50 transition-all font-bold flex items-center justify-center gap-2 active:scale-95">
          <span class="material-icons text-[18px]">upload</span>
          นำเข้าเมนู (Import)
        </button>
        <input type="file" #fileInputSub (change)="onFileSelected($event)" accept=".json" class="hidden">
        <button (click)="onRefresh()"
          class="w-full sm:w-auto p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all active:scale-95 flex items-center justify-center">
          <span class="material-icons">refresh</span>
        </button>
        <button *ngIf="canCreate" (click)="navigateToCreateMenu()"
          class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-2xl hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2">
          <span class="material-icons text-xl">add_circle</span>
          เพิ่มรายการเมนู
        </button>
      </div>
    </div>

    <div
      class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden">
      <div class="p-6 border-b border-slate-100/50 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">list</span>
          รายการเมนู ({{ filteredMenuData().length }})
        </h3>
        <div class="relative w-full sm:max-w-sm">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
          <input type="text" placeholder="ค้นหาโดยชื่อ หรือ Path..." [ngModel]="menuSearchText()"
            (ngModelChange)="menuSearchText.set($event); onSearchMenus()"
            class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none">
        </div>
      </div>

      <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
        <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
          <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
            <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
              <th (click)="sortData('number')" class="p-4 cursor-pointer hover:text-slate-600 w-[90px]">ลำดับ</th>
              <th (click)="sortData('id')" class="p-4 cursor-pointer hover:text-slate-600 w-[90px]">ID</th>
              <th (click)="sortData('name')" class="p-4 cursor-pointer hover:text-slate-600">ชื่อเมนู</th>
              <th (click)="sortData('pathId')" class="p-4 cursor-pointer hover:text-slate-600 w-[100px]">Path ID</th>
              <th (click)="sortData('path')" class="p-4 cursor-pointer hover:text-slate-600">Angular Router Path</th>
              <th (click)="sortData('status')" class="p-4 cursor-pointer hover:text-slate-600">สถานะ</th>
              <th (click)="sortData('createDate')" class="p-4 cursor-pointer hover:text-slate-600">วันที่สร้าง</th>
              <th class="p-4 text-center w-[120px]">จัดการ</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
            <tr *ngFor="let m of filteredAndPaginatedMenuData(); trackBy: trackById"
              class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all">
              <td class="p-4 font-mono font-bold">{{ m.number }}</td>
              <td class="p-4 font-mono text-slate-400">{{ m.id }}</td>
              <td class="p-4">
                <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ m.name }}</span>
              </td>
              <td class="p-4 font-mono text-xs font-bold text-amber-500">{{ m.pathId ?? '-' }}</td>
              <td class="p-4 font-mono text-xs font-bold text-slate-500 dark:text-slate-400">{{ m.path || '-' }}</td>
              <td class="p-4">
                <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold" [ngClass]="m.status
                    ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                    : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'">
                  <span class="w-1.5 h-1.5 rounded-full"
                    [ngClass]="m.status ? 'bg-emerald-500' : 'bg-slate-400'"></span>
                  {{ m.status ? 'ใช้งาน' : 'ปิดใช้งาน' }}
                </span>
              </td>
              <td class="p-4 text-slate-400 text-xs whitespace-nowrap">{{ m.createDate | date:'dd/MM/yyyy HH:mm' }}</td>
              <td class="p-4 text-center">
                <div class="flex items-center justify-center gap-2">
                  <button *ngIf="canUpdate" (click)="navigateToEditMenu(m)"
                    class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all">
                    <span class="material-icons text-base">edit</span>
                  </button>
                  <button *ngIf="canDelete" (click)="onDeleteMenu(m)"
                    class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-rose-400 text-slate-400 hover:text-rose-500 transition-all">
                    <span class="material-icons text-base">delete</span>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="filteredAndPaginatedMenuData().length === 0 && !isLoading()">
              <td colspan="8" class="py-20 text-center text-slate-400">
                <span class="material-icons text-4xl mb-2">menu_open</span>
                <p class="font-bold">ยังไม่มีรายการเมนูในกลุ่มนี้</p>
                <p *ngIf="canCreate" class="text-sm mt-1">กดปุ่ม "เพิ่มรายการเมนู" เพื่อเริ่มต้น</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
          <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }}
            รายการ</span>
          <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 text-sm rounded-lg font-bold px-2 py-1 outline-none">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
            <span class="material-icons text-sm">chevron_left</span>
          </button>
          <button *ngFor="let page of pagesArray" (click)="setPage(page)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold"
            [ngClass]="page === currentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 hover:bg-amber-50'">
            {{ page }}
          </button>
          <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages || totalPages === 0"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Modals -->
  <app-modal-group-sub-menu *ngIf="isSubModalOpen()" [data]="selectedSubItem()" (close)="closeSubModal()"
    (saveSuccess)="onRefresh()"></app-modal-group-sub-menu>

  <app-modal-menu-list *ngIf="isMenuModalOpen() && menuPresetContext" [data]="selectedMenuItem()"
    [presetContext]="menuPresetContext" (close)="closeMenuModal()" (saveSuccess)="onRefresh()">
  </app-modal-menu-list>

  <!-- Import Menu Modal -->
  <div *ngIf="isImportModalOpen()"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
    <div
      class="bg-white/95 dark:bg-slate-900/95 backdrop-blur-md rounded-2xl shadow-2xl border border-slate-100/50 dark:border-slate-800 max-w-xl w-full p-6 animate-fade-in-up overflow-hidden">
      <!-- Modal Header -->
      <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-4 mb-4">
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center">
            <span class="material-icons">cloud_upload</span>
          </div>
          <div>
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">นำเข้าโครงสร้างเมนู</h3>
            <p class="text-xs text-slate-500 dark:text-slate-400">ไฟล์: {{ selectedFileName() }}</p>
          </div>
        </div>
        <button (click)="closeImportModal()" class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200">
          <span class="material-icons">close</span>
        </button>
      </div>

      <!-- Summary Stats -->
      <div class="grid grid-cols-3 gap-3 mb-6">
        <div
          class="bg-slate-50 dark:bg-slate-800/60 p-3 rounded-xl text-center border border-slate-100 dark:border-slate-800">
          <div class="text-xl font-bold text-amber-500">{{ importSummary().groupMenusCount }}</div>
          <div class="text-xs text-slate-400">กลุ่มเมนูหลัก</div>
        </div>
        <div
          class="bg-slate-50 dark:bg-slate-800/60 p-3 rounded-xl text-center border border-slate-100 dark:border-slate-800">
          <div class="text-xl font-bold text-indigo-500">{{ importSummary().groupSubMenusCount }}</div>
          <div class="text-xs text-slate-400">กลุ่มเมนูย่อย</div>
        </div>
        <div
          class="bg-slate-50 dark:bg-slate-800/60 p-3 rounded-xl text-center border border-slate-100 dark:border-slate-800">
          <div class="text-xl font-bold text-emerald-500">{{ importSummary().menuListsCount }}</div>
          <div class="text-xs text-slate-400">รายการเมนู</div>
        </div>
      </div>

      <!-- Import Strategy Options -->
      <div class="mb-6 space-y-3">
        <label class="block text-xs font-bold uppercase text-slate-400">รูปแบบการจัดการข้อมูลซ้ำ</label>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 text-xs">
          <label (click)="importMode.set('skip')"
            class="flex items-center gap-2 p-3 rounded-xl border cursor-pointer transition-all"
            [ngClass]="importMode() === 'skip' ? 'border-amber-400 bg-amber-50/50 dark:bg-amber-950/20 text-slate-800 dark:text-slate-100 font-bold' : 'border-slate-200 dark:border-slate-800 text-slate-500'">
            <input type="radio" name="importMode" value="skip" [checked]="importMode() === 'skip'"
              class="text-amber-500 focus:ring-amber-400">
            <span>ข้ามรายการเดิม</span>
          </label>
          <label (click)="importMode.set('update')"
            class="flex items-center gap-2 p-3 rounded-xl border cursor-pointer transition-all"
            [ngClass]="importMode() === 'update' ? 'border-amber-400 bg-amber-50/50 dark:bg-amber-950/20 text-slate-800 dark:text-slate-100 font-bold' : 'border-slate-200 dark:border-slate-800 text-slate-500'">
            <input type="radio" name="importMode" value="update" [checked]="importMode() === 'update'"
              class="text-amber-500 focus:ring-amber-400">
            <span>อัปเดตรายการเดิม</span>
          </label>
          <label (click)="importMode.set('force')"
            class="flex items-center gap-2 p-3 rounded-xl border cursor-pointer transition-all"
            [ngClass]="importMode() === 'force' ? 'border-amber-400 bg-amber-50/50 dark:bg-amber-950/20 text-slate-800 dark:text-slate-100 font-bold' : 'border-slate-200 dark:border-slate-800 text-slate-500'">
            <input type="radio" name="importMode" value="force" [checked]="importMode() === 'force'"
              class="text-amber-500 focus:ring-amber-400">
            <span>สร้างใหม่ทั้งหมด</span>
          </label>
        </div>
      </div>

      <!-- Progress Indicator -->
      <div *ngIf="importProgress().total > 0" class="mb-6 space-y-2">
        <div class="flex justify-between text-xs text-slate-500 dark:text-slate-400">
          <span class="truncate">{{ importProgress().text }}</span>
          <span class="font-mono font-bold">{{ importProgress().current }}/{{ importProgress().total }}</span>
        </div>
        <div class="w-full bg-slate-100 dark:bg-slate-800 h-2 rounded-full overflow-hidden">
          <div class="bg-amber-400 h-full transition-all duration-300"
            [style.width.%]="(importProgress().current / importProgress().total) * 100"></div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-slate-100 dark:border-slate-800">
        <button (click)="closeImportModal()" [disabled]="isLoading()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 text-sm font-bold transition-all disabled:opacity-50">
          ยกเลิก
        </button>
        <button (click)="importMenuData()" [disabled]="isLoading()"
          class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white text-sm font-bold shadow-lg shadow-amber-200/50 transition-all flex items-center gap-2 disabled:opacity-50">
          <span class="material-icons text-base">cloud_download</span>
          ยืนยันนำเข้าข้อมูล
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="isDeleteSubModalOpen()" title="ยืนยันการลบกลุ่มเมนูย่อย?" message="ต้องการลบกลุ่มเมนูย่อย"
  [highlight]="subToDelete()?.name || ''" messageSuffix="หรือไม่? (ไม่สามารถลบได้หากมีรายการเมนูอ้างอิง)"
  confirmLabel="ลบข้อมูล" (confirm)="confirmDeleteSub()" (cancel)="closeDeleteSubModal()">
</app-pss-confirm-modal>

<app-pss-confirm-modal *ngIf="isDeleteMenuModalOpen()" title="ยืนยันการลบรายการเมนู?" message="ต้องการลบรายการเมนู"
  [highlight]="menuToDelete()?.name || ''" messageSuffix="หรือไม่?" confirmLabel="ลบข้อมูล"
  (confirm)="confirmDeleteMenu()" (cancel)="closeDeleteMenuModal()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>